import { render } from "./ImageUpdate.vue?vue&type=template&id=6039953e"
import script from "./ImageUpdate.vue?vue&type=script&lang=js"
export * from "./ImageUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__